import tw from "twin.macro"
import styled from "styled-components"
import guillaumeBackground from "../../images/guillaume_lafond_images/GSTL0736.jpg"
import album1 from "../../images/guillaume_lafond_images/album1.jpg"
import album2 from "../../images/guillaume_lafond_images/album2.jpeg"
import album4 from "../../images/guillaume_lafond_images/Cover_SousMonChapeau_G3000x3000.png"

const Container = styled.div`
  ${tw`relative bg-center bg-no-repeat min-h-screen w-screen`}
  background-image: url(${guillaumeBackground});
  background-size: cover;
  background-position: left center;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  height: 100vh;
  min-height: 500px;

  /* Media Query for screens smaller than 1200px */
  @media (max-width: 1400px) {
    background-size: cover;
    background-position: 50% center;
  }

  /* Media Query for screens smaller than 768px */
  @media (max-width: 900px) {
    background-size: cover;
    background-position: 70% center;
  }

  /* Media Query for screens smaller than 500px */
  @media (max-width: 500px) {
    background-size: cover;
    background-position: 75% center;
  }
`

const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-black opacity-25`

const HeroContainer = tw.div`z-20 relative mx-auto h-full flex flex-col`

const Content = styled.div`
  ${tw`flex h-full items-start`}  // remove justify-center
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 7%;
`


const LeftColumn = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2 columns */
  gap: 2rem;

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }

  width: 100%;
  max-width: 600px;
`



const AlbumAndButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  
`

const Image = styled.img`
  ${tw`rounded-lg`}
  width: 220px;
  height: auto;
  border: 2px solid #4e3b30;
  border-radius: 10px;

  @media (max-width: 900px) {
    width: 180px;
  }

  @media (max-width: 700px) {
    width: 150px;
  }

  @media (max-width: 500px) {
    width: 130px;
  }
`

const Button = styled.a`
  ${tw`text-sm py-2 px-4 font-medium rounded-md transition duration-300 ease-in-out`}
  text-decoration: none;
  background-color: rgba(175,155,135,1);
  color: white;
  cursor: pointer;
  display: block;
  text-align: center;
  margin-top: 0.75rem;
  width: fit-content;

  &:hover {
    background-color: rgba(155,135,115,1);
  }

  @media (max-width: 700px) {
    width: fit-content;
    font-size: 0.9rem;
  }

  @media (max-width: 500px) {
    width: fit-content;
    font-size: 0.85rem;
  }
`

const BackgroundMusique = () => {
  return (
    <Container>
      <OpacityOverlay />
      <HeroContainer>
        <Content>
          <LeftColumn>
            <AlbumAndButtonContainer>
              <Image src={album1 || "/placeholder.svg"} alt="À destination - Guillaume Lafond" />
              <Button href="https://mp3-disques.lnk.to/GuillaumeLafond_Adestination" target="_blank">
                Écouter ici
              </Button>
            </AlbumAndButtonContainer>

            <AlbumAndButtonContainer>
              <Image src={album2 || "/placeholder.svg"} alt="Grande Ourse - Guillaume Lafond" />
              <Button
                href="https://lnk.to/grandeourse?fbclid=IwAR0Os5TvQ5mcYYcGdunXZPMe06uHsOuUSD_KD8nQOLsiRJ_MNcRj-Jbfz34"
                target="_blank"
              >
                Écouter ici
              </Button>
            </AlbumAndButtonContainer>

            <AlbumAndButtonContainer>
              <Image src={album4 || "/placeholder.svg"} alt="Mon chapeau - Guillaume Lafond" />
              <Button href="https://ffm.to/guillaumelafond-sousmonchapeau" target="_blank">
              Écouter ici
              </Button>
            </AlbumAndButtonContainer>
          </LeftColumn>
        </Content>
      </HeroContainer>
    </Container>
  )
}

export default BackgroundMusique

